import { CheckCircle2, FileText } from "lucide-react";

interface LocalSEOHubSummaryProps {
  language: 'es' | 'en';
}

export const LocalSEOHubSummary = ({ language }: LocalSEOHubSummaryProps) => {
  const content = {
    es: {
      title: "En resumen",
      bullets: [
        "El SEO local optimiza tu presencia en Google Maps y búsquedas geográficas específicas.",
        "Es ideal para empresas B2B que atienden clientes en áreas geográficas definidas.",
        "Resuelve problemas como: no aparecer en búsquedas locales, bajo tráfico desde Google Maps, o depender solo de referencias.",
        "Impacta directamente en la generación de leads calificados de tu zona de servicio.",
        "El próximo paso recomendado es una reunión inicial gratuita de 30 minutos para evaluar tu visibilidad local actual."
      ]
    },
    en: {
      title: "In summary",
      bullets: [
        "Local SEO optimizes your presence in Google Maps and specific geographic searches.",
        "It's ideal for B2B companies that serve clients in defined geographic areas.",
        "It solves problems like: not appearing in local searches, low traffic from Google Maps, or depending only on referrals.",
        "It directly impacts the generation of qualified leads from your service area.",
        "The recommended next step is a free 30-minute initial consultation to evaluate your current local visibility."
      ]
    }
  };

  const t = content[language];

  return (
    <section className="section-padding bg-secondary/30">
      <div className="container-custom">
        <div className="max-w-3xl mx-auto">
          <div className="bg-background rounded-2xl p-8 border border-border shadow-sm">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-full bg-brand/10 flex items-center justify-center">
                <FileText className="w-5 h-5 text-brand" />
              </div>
              <h2 className="text-xl font-bold">{t.title}</h2>
            </div>
            
            <ul className="space-y-4">
              {t.bullets.map((bullet, index) => (
                <li key={index} className="flex items-start gap-3">
                  <CheckCircle2 className="w-5 h-5 text-brand mt-0.5 flex-shrink-0" />
                  <span className="text-foreground">{bullet}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
